/**------------------------------------------------------
 * Ignore Encryption
 * -----------------
 * > In sockets messages like "error" and so on should
 * > not have an encryption
 */
export const SECURE_WHITELIST_SOCKET_ENCRYPTION: string[] = [
	'error'
];
